module.exports = "<div id=\"auth_bg\">\n  <div id=\"auth\">\n    <mat-tab-group>\n      <mat-tab label=\"Авторизация\">\n        <app-form-login></app-form-login>\n      </mat-tab>\n      <mat-tab label=\"Регистрация\">\n        <app-form-register></app-form-register>\n      </mat-tab>\n    </mat-tab-group>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/auth/auth.component.html
// module id = ./src/app/components/auth/auth.component.html
// module chunks = main